// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__pO_yH","popModal":"logo_popModal__3cU5F","slideRight":"logo_slideRight__LMbzX","slideLeft":"logo_slideLeft__yapND","bottomModal":"logo_bottomModal__FL_n8"};